/**
 * Factory function for creating localstorage wrapper
 * @return {object} functions for localstorage acces
 */

const storageWrapper = () => {
  const getToken = () => window.localStorage.getItem('authUser')
  // const setToken = token => window.localStorage.setItem('authUser', token)
  const getUserId = () => window.localStorage.getItem('userId')
  const setUserId = id => window.localStorage.setItem('userId', id)
  const setUser = loginName => window.localStorage.setItem('user', loginName)
  const getUser = () => window.localStorage.getItem('user')
  const clear = () => window.localStorage.clear()

  return {
    getToken,
    // setToken,
    getUserId,
    setUserId,
    setUser,
    getUser,
    clear
  }
}

export default storageWrapper
